/* eBook offer cart attributes. One place that writes them, so the order shows what really happened.
 *   'eBook popup: shown'  = 'yes' once the add-to-cart popup has opened.
 *   'eBook popup: added'  = 'popup' | 'cart card' after Shopify confirmed the add;
 *                           '<source>, then removed' when the eBook later left the cart.
 *   'eBook popup' (legacy) is kept for old reports, but now overwritten to match the cart
 *                           ('added eBook, then removed' when the eBook is no longer there).
 * Reconciled on every drawer cart update and on page load. Loaded before ywr-atc-ebook-popup.js and ywr-order-bump.js. */
(function () {
  'use strict';
  var VARIANT = '43064030036061', K_LEGACY = 'eBook popup', K_SHOWN = 'eBook popup: shown', K_ADDED = 'eBook popup: added', GONE = ', then removed';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var queue = Promise.resolve();
  function post(attrs) { return fetch(root + 'cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: attrs }) }); }
  // Writes run one at a time, in order. Inside the queue (reconcile) post directly, or the chain waits on itself.
  function write(attrs) { queue = queue.then(function () { return post(attrs); }).catch(function () {}); return queue; }
  function getCart() { return fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function hasEbook(cart) { return !!cart && (cart.items || []).some(function (i) { return String(i.variant_id) === VARIANT && i.quantity > 0; }); }
  // What this session really did, so a write lost to a concurrent cart update is put back by reconcile.
  var MEM = 'ywr-ebook-attr-v1';
  function mem(patch) { var m = {}; try { m = JSON.parse(sessionStorage.getItem(MEM) || '{}'); } catch (_) {} if (patch) { Object.assign(m, patch); try { sessionStorage.setItem(MEM, JSON.stringify(m)); } catch (_) {} } return m; }
  function strip(v) { return String(v || '').replace(GONE, ''); }
  // Make the attributes match the cart: flag a removed eBook, un-flag one that came back.
  function reconcile(cart) {
    var a = (cart && cart.attributes) || {}, inCart = hasEbook(cart), up = {};
    var m = mem(); if (m.token && cart && cart.token && m.token !== cart.token) { m = {}; try { sessionStorage.removeItem(MEM); } catch (_) {} } else if (cart && cart.token && !m.token && Object.keys(m).length) mem({ token: cart.token });
    var added = a[K_ADDED] || m.added, legacy = a[K_LEGACY] || m.legacy;
    if (m.shown && a[K_SHOWN] !== 'yes') up[K_SHOWN] = 'yes';
    if (m.added && !a[K_ADDED]) up[K_ADDED] = added;
    if (m.legacy && !a[K_LEGACY]) up[K_LEGACY] = legacy;
    if (added) {
      var want = inCart ? strip(added) : strip(added) + GONE;
      if (want !== added) up[K_ADDED] = want;
    }
    if (legacy && /^added eBook/.test(legacy)) {
      var wantL = inCart ? strip(legacy) : strip(legacy) + GONE;
      if (wantL !== legacy) up[K_LEGACY] = wantL;
    }
    return Object.keys(up).length ? post(up) : Promise.resolve();
  }
  var timer = null;
  function check() { clearTimeout(timer); timer = setTimeout(function () { queue = queue.then(getCart).then(reconcile).catch(function () {}); }, 400); }
  window.YWREbookAttr = {
    variantId: VARIANT,
    shown: function () { mem({ shown: 1, legacy: 'saw popup' }); setTimeout(check, 2500); return write({ 'eBook popup: shown': 'yes', 'eBook popup': 'saw popup' }); },
    declined: function () { mem({ legacy: 'clicked No thanks' }); setTimeout(check, 2500); return write({ 'eBook popup': 'clicked No thanks' }); },
    // Call only after Shopify answered the add with 2xx.
    added: function (source) { var a = {}; a[K_ADDED] = source; a[K_LEGACY] = source === 'popup' ? 'added eBook' : 'added eBook (' + source + ')'; mem({ added: a[K_ADDED], legacy: a[K_LEGACY] }); setTimeout(check, 2500); return write(a); },
    reconcile: reconcile, check: check
  };
  document.addEventListener('ywr:cart-updated', check);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check); else check();
})();
